// extracted by mini-css-extract-plugin
export default {"root":"UpXKJ","icon":"KgRF2","description":"NUX1C","tablet":"aK6ro","backButton":"p5Lhh"};